import { useInputPageHook } from "../hooks";
import { DisclaimerStyled } from "../styles/inputForms.styled";

const Disclaimer = () => {
  const { parsedTermDisclaimer } = useInputPageHook();
  return <DisclaimerStyled>{parsedTermDisclaimer}</DisclaimerStyled>;
};

export default Disclaimer;
